import { render, staticRenderFns } from "./differs.vue?vue&type=template&id=8cf7f258&scoped=true"
import script from "./differs.vue?vue&type=script&lang=js"
export * from "./differs.vue?vue&type=script&lang=js"
import style0 from "./differs.vue?vue&type=style&index=0&id=8cf7f258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf7f258",
  null
  
)

export default component.exports